<p [class.description]="!isWrapperFlex()" [class.flex-container]="isWrapperFlex()">
  @if (showLabelText()) {
    <ui-label [config]="labelConfig()">
      {{ labelText() | translate }}
    </ui-label>
  }
  @if (showCreditMessage() && creditMessage()) {
    <span class="body-s credit-date">
      {{ creditMessage() }}
    </span>
  }
</p>
